import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { baseTimeRecordsEffects, baseTimeRecordsReducer } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('timeRecords', baseTimeRecordsReducer.BaseTimeRecords),
    EffectsModule.forFeature([baseTimeRecordsEffects.BaseTimeRecordsEffects]),
  ],
})
export class BaseTimeRecordingsStoreModule {}
